import * as React from 'react';

function PhotoUploadBaloonPrizeContestMobile({ handleClick, ...props }) {
    return (
        <svg
            width="100%"
            viewBox="0 0 496 309"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M125.641 10.8658C132.833 10.3576 141.007 9.69645 149.83 8.98288L178.5 8.76789C184.032 8.90632 188.527 9.01878 191.627 9.01878C202.283 9.01878 218.868 9.52809 231.058 9.90244C236.884 10.0813 241.706 10.2294 244.397 10.2763C258.999 10.531 267.27 10.0361 272.596 9.19821L353.161 3.6993C355.518 3.34363 358.532 2.9404 362.005 2.61836C365.427 2.30108 369.953 2 375.234 2C441.002 2 494.317 33.7858 494.317 111.998C494.317 134.48 470.699 186.054 460.546 201.691C453.607 206.738 443.429 273 403.181 273C385.095 273 311.926 263.964 301.866 264.836L266.986 263.449C265.924 263.39 264.903 263.333 263.928 263.28L201.015 264.836C178.5 264.836 158 263.28 140.101 261.225C126.701 259.687 88.6043 260 79.1678 260.194C79.8987 260.233 80.636 260.26 81.3798 260.276C76.0621 260.312 75.9985 260.26 79.1678 260.194C15.2915 256.848 0.601234 169.209 2.11976 109.162C2.11976 84.0118 -1.61436 38.7116 32.6197 19.7595C60.007 4.59779 94.9422 12.1355 125.641 10.8658Z"
                fill="#FFEACC"
            />
            <path
                d="M2.11976 109.162C0.583859 169.896 15.6298 258.857 81.3798 260.276C60.2285 260.418 122.201 259.17 140.101 261.225C158 263.28 178.5 264.836 201.015 264.836L263.928 263.28C264.903 263.333 265.924 263.39 266.986 263.449L301.866 264.836C311.926 263.964 385.095 273 403.181 273C443.429 273 453.607 206.738 460.546 201.691C470.699 186.054 494.317 134.48 494.317 111.998C494.317 33.7858 441.002 2 375.234 2C369.953 2 365.427 2.30108 362.005 2.61836C358.532 2.9404 355.518 3.34363 353.161 3.6993L272.596 9.19821C267.27 10.0361 258.999 10.531 244.397 10.2763C241.706 10.2294 236.884 10.0813 231.058 9.90244C218.868 9.52809 202.283 9.01878 191.627 9.01878C188.527 9.01878 184.032 8.90632 178.5 8.76789L149.83 8.98288C141.007 9.69645 132.833 10.3576 125.641 10.8658C94.9422 12.1355 60.007 4.59779 32.6197 19.7595C-1.61436 38.7116 2.11976 84.0118 2.11976 109.162Z"
                stroke="#FBA919"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <text
                fill="black"
                xmlSpace="preserve"
                style={{
                    whiteSpace: 'pre'
                }}
                fontFamily="Roboto"
                fontSize={16}
                letterSpacing="0.02em"
            >
                <tspan x={66} y={143.469}>
                    {'Če je v tvojem osebnem arhivu kakšna fotografija '}
                </tspan>
                <tspan x={66} y={165.469}>
                    {'te izletniške ideje jo lahko naložiš in s tem '}
                </tspan>
                <tspan x={66} y={187.469}>
                    {'sodeluješ v izboru za glavno nagrado '}
                </tspan>
                <tspan x={62.756} y={209.469}>
                    {' in '}
                </tspan>
                <tspan x={260.92} y={209.469}>
                    .
                </tspan>
            </text>
            <text
                fill="black"
                xmlSpace="preserve"
                style={{
                    whiteSpace: 'pre'
                }}
                fontFamily="Roboto"
                fontSize={16}
                fontWeight="bold"
                letterSpacing="0.02em"
            >
                <tspan x={344.043} y={187.469}>
                    Nikon Z 30
                </tspan>
                <tspan x={82.692} y={209.469}>
                    15 majic Kam za vikend
                </tspan>
            </text>
            <text
                fill="#FBA919"
                xmlSpace="preserve"
                style={{
                    whiteSpace: 'pre'
                }}
                fontFamily="Paytone One"
                fontSize={30}
                letterSpacing="0em"
            >
                <tspan x={66} y={72.95}>
                    {'IMAŠ KAKŠNO DOBRO '}
                </tspan>
                <tspan x={66} y={107.95}>
                    FOTOGRAFIJO?
                </tspan>
            </text>
            <g onClick={handleClick} style={{ cursor: 'pointer' }}>
                <path
                    d="M181 266C181 254.954 189.954 246 201 246H432V266C432 277.046 423.046 286 412 286H201C189.954 286 181 277.046 181 266V266Z"
                    fill="#414142"
                />
                <text
                    fill="white"
                    xmlSpace="preserve"
                    style={{
                        whiteSpace: 'pre'
                    }}
                    fontFamily="Roboto"
                    fontSize={14}
                    fontWeight="bold"
                    letterSpacing="0.05em"
                >
                    <tspan x={228.433} y={271.285}>
                        Dodaj fotografije in sodeluj
                    </tspan>
                </text>
                <g clipPath="url(#clip0)">
                    <g
                        style={{
                            mixBlendMode: 'multiply'
                        }}
                        opacity={0.3}
                    >
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.556 297.58L182.118 301.333L192.194 272.404L209.306 277.402L196.1 306.319Z"
                                fill="white"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.515 297.525L182.118 301.333L192.194 272.404L209.11 277.402L196.1 306.319Z"
                                fill="#EFEFEF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.473 297.468L182.118 301.333L192.194 272.404L208.914 277.402L196.1 306.319Z"
                                fill="#DFDFDF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.43 297.411L182.118 301.333L192.194 272.404L208.719 277.402L196.1 306.319Z"
                                fill="#CFCFCF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.389 297.354L182.118 301.333L192.194 272.404L208.522 277.402L196.1 306.319Z"
                                fill="#BFBFBF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.347 297.298L182.118 301.333L192.194 272.404L208.327 277.402L196.1 306.319Z"
                                fill="#AFAFAF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.305 297.241L182.118 301.333L192.194 272.404L208.13 277.402L196.1 306.319Z"
                                fill="#9F9F9F"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.262 297.184L182.118 301.333L192.194 272.404L207.934 277.402L196.1 306.319Z"
                                fill="#8F8F8F"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.221 297.127L182.118 301.333L192.194 272.404L207.739 277.402L196.1 306.319Z"
                                fill="#808080"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.179 297.071L182.118 301.333L192.194 272.404L207.542 277.402L196.1 306.319Z"
                                fill="#707070"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.137 297.014L182.118 301.333L192.194 272.404L207.347 277.402L196.1 306.319Z"
                                fill="#606060"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.096 296.957L182.118 301.333L192.194 272.404L207.15 277.402L196.1 306.319Z"
                                fill="#505050"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.053 296.9L182.118 301.333L192.194 272.404L206.955 277.402L196.1 306.319Z"
                                fill="#404040"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L192.011 296.843L182.118 301.333L192.194 272.404L206.759 277.402L196.1 306.319Z"
                                fill="#303030"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L191.969 296.787L182.118 301.333L192.194 272.404L206.562 277.402L196.1 306.319Z"
                                fill="#202020"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L191.928 296.73L182.118 301.333L192.194 272.404L206.367 277.402L196.1 306.319Z"
                                fill="#101010"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M196.1 306.319L194.635 303.307L191.885 296.673L182.118 301.333L192.194 272.404L206.17 277.402L196.1 306.319Z"
                                fill="black"
                            />
                        </g>
                    </g>
                    <path
                        d="M196.1 306.319L194.635 303.307L191.885 296.673L182.118 301.333L192.194 272.404L206.17 277.402L196.1 306.319Z"
                        fill="url(#paint0_linear)"
                    />
                    <path
                        d="M195.995 304.568L195.248 303.037L192.232 295.762L183.286 300.03L192.604 273.279L192.814 273.354L205.313 277.824L205.238 278.039L195.995 304.568ZM192.464 295.143L195.655 302.843L195.928 303.397L204.743 278.09L192.878 273.847L184.065 299.149L192.464 295.143Z"
                        fill="url(#paint1_linear)"
                    />
                    <g
                        style={{
                            mixBlendMode: 'multiply'
                        }}
                        opacity={0.3}
                    >
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.867 297.994L215.832 296.99L209.5 295.37L207.449 304.027L193.297 278.992L206.617 272.97L219.867 297.994Z"
                                fill="white"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.868 297.994L215.902 296.99L209.585 295.313L207.45 304.027L193.423 278.949L206.687 272.927L219.868 297.994Z"
                                fill="#EFEFEF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.868 297.994L215.971 296.99L209.669 295.256L207.449 304.027L193.55 278.906L206.758 272.885L219.868 297.994Z"
                                fill="#DFDFDF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.868 297.994L216.043 296.99L209.754 295.199L207.45 304.027L193.676 278.864L206.828 272.843L219.868 297.994Z"
                                fill="#CFCFCF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.867 297.994L216.112 296.99L209.836 295.143L207.449 304.027L193.801 278.821L206.897 272.8L219.867 297.994Z"
                                fill="#BFBFBF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.867 297.994L216.182 296.99L209.921 295.086L207.449 304.027L193.927 278.778L206.967 272.757L219.867 297.994Z"
                                fill="#AFAFAF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.868 297.994L216.252 296.99L210.005 295.029L207.449 304.027L194.053 278.737L207.037 272.715L219.868 297.994Z"
                                fill="#9F9F9F"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.867 297.994L216.321 296.99L210.089 294.972L207.449 304.027L194.18 278.694L207.108 272.672L219.867 297.994Z"
                                fill="#8F8F8F"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.868 297.994L216.392 296.99L210.173 294.915L207.449 304.027L194.306 278.651L207.178 272.629L219.868 297.994Z"
                                fill="#808080"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.868 297.994L216.462 296.99L210.258 294.859L207.45 304.027L194.432 278.608L207.247 272.586L219.868 297.994Z"
                                fill="#707070"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.867 297.994L216.531 296.99L210.341 294.802L207.449 304.027L194.557 278.566L207.316 272.545L219.867 297.994Z"
                                fill="#606060"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.867 297.994L216.601 296.99L210.424 294.745L207.449 304.027L194.683 278.524L207.388 272.502L219.867 297.994Z"
                                fill="#505050"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.867 297.994L216.671 296.99L210.509 294.688L207.449 304.027L194.81 278.481L207.457 272.459L219.867 297.994Z"
                                fill="#404040"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.868 297.994L216.742 296.99L210.593 294.632L207.449 304.027L194.936 278.438L207.527 272.417L219.868 297.994Z"
                                fill="#303030"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.868 297.994L216.812 296.99L210.677 294.575L207.45 304.027L195.062 278.396L207.597 272.375L219.868 297.994Z"
                                fill="#202020"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.867 297.994L216.881 296.99L210.76 294.518L207.449 304.027L195.187 278.353L207.666 272.332L219.867 297.994Z"
                                fill="#101010"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M219.867 297.994L216.951 296.99L210.845 294.461L207.449 304.027L195.312 278.31L207.738 272.289L219.867 297.994Z"
                                fill="black"
                            />
                        </g>
                    </g>
                    <path
                        d="M219.867 297.994L216.951 296.99L210.845 294.461L207.449 304.027L195.312 278.31L207.738 272.289L219.867 297.994Z"
                        fill="url(#paint2_linear)"
                    />
                    <path
                        d="M207.37 302.43L196.124 278.6L207.454 273.111L218.695 296.943L217.171 296.418L210.487 293.648L207.37 302.43ZM196.721 278.814L207.311 301.25L210.223 293.046L217.329 295.986L217.835 296.159L207.238 273.717L196.721 278.814Z"
                        fill="url(#paint3_linear)"
                    />
                    <g
                        style={{
                            mixBlendMode: 'multiply'
                        }}
                        opacity={0.3}
                    >
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.254 288.906C212.295 288.759 221.128 279.57 220.984 268.381C220.839 257.192 211.772 248.24 200.731 248.386C189.69 248.533 180.856 257.722 181.001 268.911C181.145 280.101 190.213 289.052 201.254 288.906Z"
                                fill="white"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.256 288.756C212.297 288.61 221.13 279.42 220.986 268.231C220.841 257.042 211.774 248.09 200.733 248.237C189.692 248.383 180.858 257.573 181.003 268.762C181.147 279.951 190.215 288.903 201.256 288.756Z"
                                fill="#F2F2F2"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.261 288.604C212.302 288.457 221.135 279.268 220.991 268.079C220.846 256.89 211.779 247.938 200.738 248.084C189.697 248.231 180.863 257.42 181.008 268.609C181.152 279.799 190.22 288.75 201.261 288.604Z"
                                fill="#E5E5E5"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.249 288.461C212.29 288.316 221.125 279.129 220.982 267.939C220.84 256.75 211.774 247.797 200.733 247.941C189.692 248.086 180.857 257.274 180.999 268.463C181.142 279.652 190.208 288.605 201.249 288.461Z"
                                fill="#D9D9D9"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.252 288.311C212.293 288.167 221.128 278.979 220.985 267.79C220.843 256.6 211.777 247.647 200.736 247.792C189.695 247.936 180.86 257.124 181.002 268.313C181.145 279.502 190.211 288.456 201.252 288.311Z"
                                fill="#CCCCCC"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.256 288.16C212.297 288.016 221.132 278.828 220.989 267.639C220.847 256.45 211.781 247.496 200.74 247.641C189.699 247.785 180.864 256.973 181.006 268.162C181.149 279.351 190.215 288.305 201.256 288.16Z"
                                fill="#BFBFBF"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.261 288.009C212.302 287.865 221.137 278.677 220.994 267.488C220.852 256.298 211.785 247.345 200.744 247.49C189.703 247.634 180.869 256.822 181.011 268.011C181.154 279.2 190.22 288.154 201.261 288.009Z"
                                fill="#B2B2B2"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.265 287.858C212.306 287.714 221.141 278.526 220.998 267.337C220.855 256.148 211.789 247.194 200.748 247.339C189.707 247.483 180.872 256.671 181.015 267.86C181.158 279.049 190.224 288.003 201.265 287.858Z"
                                fill="#A5A5A5"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.251 287.716C212.292 287.574 221.128 278.388 220.988 267.198C220.847 256.009 211.783 247.054 200.742 247.197C189.701 247.339 180.864 256.525 181.005 267.715C181.145 278.904 190.21 287.859 201.251 287.716Z"
                                fill="#989898"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.255 287.565C212.296 287.423 221.132 278.237 220.992 267.047C220.851 255.858 211.786 246.903 200.745 247.046C189.704 247.188 180.868 256.375 181.009 267.564C181.149 278.753 190.214 287.708 201.255 287.565Z"
                                fill="#8C8C8C"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.258 287.414C212.299 287.272 221.135 278.086 220.995 266.896C220.854 255.707 211.789 246.752 200.748 246.895C189.707 247.037 180.871 256.223 181.012 267.413C181.152 278.602 190.217 287.557 201.258 287.414Z"
                                fill="#7F7F7F"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.263 287.264C212.304 287.121 221.14 277.935 221 266.746C220.859 255.556 211.794 246.601 200.753 246.744C189.712 246.886 180.876 256.073 181.016 267.262C181.157 278.451 190.222 287.406 201.263 287.264Z"
                                fill="#727272"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.25 287.12C212.291 286.98 221.129 277.795 220.99 266.606C220.852 255.416 211.788 246.46 200.747 246.6C189.706 246.741 180.868 255.926 181.007 267.115C181.146 278.304 190.209 287.261 201.25 287.12Z"
                                fill="#656565"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.253 286.971C212.294 286.83 221.132 277.645 220.993 266.456C220.854 255.267 211.791 246.31 200.75 246.451C189.709 246.592 180.871 255.776 181.01 266.965C181.149 278.155 190.212 287.111 201.253 286.971Z"
                                fill="#585858"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.257 286.818C212.298 286.678 221.136 277.493 220.997 266.304C220.858 255.115 211.795 246.158 200.754 246.299C189.713 246.439 180.875 255.624 181.014 266.813C181.153 278.002 190.216 286.959 201.257 286.818Z"
                                fill="#4C4C4C"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.261 286.669C212.302 286.528 221.14 277.343 221.001 266.154C220.862 254.965 211.799 246.008 200.758 246.149C189.717 246.29 180.879 255.474 181.018 266.663C181.157 277.853 190.22 286.809 201.261 286.669Z"
                                fill="#3F3F3F"
                            />
                        </g>
                        <g
                            style={{
                                mixBlendMode: 'multiply'
                            }}
                            opacity={0.3}
                        >
                            <path
                                d="M201.266 286.518C212.307 286.377 221.145 277.193 221.006 266.003C220.867 254.814 211.804 245.857 200.763 245.998C189.722 246.139 180.884 255.323 181.023 266.513C181.161 277.702 190.225 286.658 201.266 286.518Z"
                                fill="#323232"
                            />
                        </g>
                    </g>
                    <path
                        d="M201.266 286.518C212.307 286.377 221.145 277.193 221.006 266.003C220.867 254.814 211.804 245.857 200.763 245.998C189.722 246.139 180.884 255.323 181.023 266.513C181.161 277.702 190.225 286.658 201.266 286.518Z"
                        fill="url(#paint4_linear)"
                    />
                    <path
                        d="M201.007 285.332C190.631 285.332 182.189 276.777 182.189 266.261C182.189 255.746 190.631 247.191 201.007 247.191C211.384 247.191 219.825 255.746 219.825 266.261C219.825 276.777 211.384 285.332 201.007 285.332ZM201.007 247.645C190.878 247.645 182.638 255.996 182.638 266.261C182.638 276.526 190.878 284.879 201.007 284.879C211.136 284.879 219.377 276.526 219.377 266.261C219.377 255.996 211.136 247.64 201.007 247.64V247.645Z"
                        fill="url(#paint5_linear)"
                    />
                    <path
                        d="M210.833 264.752C210.651 263.81 210.471 262.681 210.254 261.745C209.947 260.434 209.871 258.827 209.16 258.597C208.601 258.416 207.783 258.755 207.224 258.874C207.181 258.417 207.996 258.769 208.213 258.5C208.35 258.33 208.097 257.57 208.051 257.309L205.454 257.841C205.018 257.93 204.473 257.934 204.079 258.118C203.686 258.302 203.851 258.061 203.747 258.377C203.673 258.601 203.884 259.131 203.924 259.374L204.988 259.157C205.037 259.478 203.769 259.594 203.456 259.63C202.434 259.748 202.387 259.205 202.066 258.384C201.507 256.945 199.086 258.01 197.991 258.23C197.453 258.338 196.693 258.349 196.436 258.942C196.06 259.806 197.04 260.704 195.768 261.184C195.358 261.338 194.366 261.64 193.941 261.551C193.822 261.526 193.667 261.313 193.442 261.274C193.082 261.225 192.53 261.452 192.175 261.521C191.941 261.567 191.541 261.567 191.337 261.683C191.089 261.821 191.072 262.049 190.918 262.155C190.523 262.432 190.083 262.175 189.824 262.774C189.652 263.17 189.671 262.97 189.65 262.531C189.633 262.204 191.512 272.793 191.687 273.333C191.996 274.275 192.603 274.208 193.354 274.074C197.945 273.254 202.51 272.231 207.08 271.304C207.947 271.13 212.037 270.933 211.736 269.375C211.436 267.817 211.13 266.292 210.833 264.752ZM189.711 265.281L189.67 265.289L189.711 265.281C189.488 265.327 189.338 265.043 189.438 264.865C189.528 265.208 189.833 265.136 189.872 264.824C189.898 264.863 189.914 264.908 189.919 264.955C189.924 265.001 189.919 265.049 189.904 265.093C189.888 265.137 189.862 265.177 189.829 265.21C189.796 265.242 189.755 265.267 189.711 265.281V265.281Z"
                        fill="#FF7004"
                    />
                    <path
                        d="M192.48 261.293L190.228 261.726C190.047 261.761 189.928 261.938 189.963 262.121L190.053 262.601C190.087 262.785 190.261 262.905 190.442 262.87L192.694 262.437C192.875 262.402 192.994 262.225 192.959 262.042L192.869 261.562C192.835 261.378 192.66 261.258 192.48 261.293Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M206.218 259.049L204.005 259.497L203.949 259.182L206.162 258.733L206.218 259.049Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M207.23 258.54L202.889 259.42L202.68 258.248L207.021 257.367L207.23 258.54Z"
                        fill="white"
                    />
                    <path
                        d="M203.169 259.295L203.106 259.308L202.909 258.202L202.972 258.19L203.169 259.295Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M203.545 259.219L203.482 259.232L203.285 258.126L203.348 258.114L203.545 259.219Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M203.89 259.148L203.827 259.162L203.63 258.056L203.693 258.043L203.89 259.148Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M204.171 259.092L204.108 259.104L203.911 257.999L203.974 257.987L204.171 259.092Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M204.452 259.035L204.389 259.047L204.192 257.941L204.255 257.928L204.452 259.035Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M204.766 258.971L204.703 258.984L204.506 257.878L204.569 257.866L204.766 258.971Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M205.078 258.907L205.017 258.92L204.818 257.815L204.881 257.802L205.078 258.907Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M205.424 258.838L205.361 258.851L205.163 257.746L205.226 257.733L205.424 258.838Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M205.737 258.775L205.674 258.787L205.478 257.682L205.539 257.669L205.737 258.775Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M206.05 258.711L205.987 258.723L205.79 257.618L205.852 257.606L206.05 258.711Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M206.362 258.649L206.299 258.661L206.103 257.554L206.165 257.542L206.362 258.649Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M206.707 258.578L206.644 258.59L206.447 257.485L206.51 257.473L206.707 258.578Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M206.988 258.521L206.925 258.534L206.729 257.428L206.791 257.415L206.988 258.521Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M201.135 258.966L201.032 258.434C200.992 258.193 200.861 257.978 200.665 257.836C200.47 257.694 200.226 257.636 199.989 257.675L196.026 258.468C195.91 258.495 195.8 258.545 195.702 258.615C195.605 258.685 195.523 258.773 195.459 258.875C195.396 258.978 195.353 259.092 195.333 259.211C195.313 259.33 195.316 259.452 195.342 259.569L195.446 260.101C195.474 260.219 195.478 260.342 195.458 260.462C195.438 260.582 195.396 260.696 195.332 260.799C195.269 260.902 195.186 260.991 195.088 261.062C194.99 261.132 194.88 261.182 194.763 261.209L189.406 262.28C189.289 262.306 189.178 262.356 189.08 262.426C188.983 262.497 188.9 262.586 188.836 262.689C188.772 262.792 188.73 262.907 188.71 263.027C188.691 263.147 188.695 263.269 188.723 263.388L188.898 264.284C188.937 264.524 189.069 264.738 189.264 264.88C189.459 265.022 189.702 265.08 189.939 265.041L208.251 261.384C208.368 261.357 208.479 261.307 208.576 261.236C208.674 261.166 208.757 261.077 208.82 260.974C208.884 260.871 208.927 260.756 208.946 260.636C208.966 260.516 208.962 260.394 208.935 260.276L208.761 259.381C208.722 259.14 208.59 258.926 208.394 258.783C208.199 258.641 207.956 258.584 207.718 258.623L202.178 259.731C202.06 259.751 201.939 259.746 201.823 259.718C201.707 259.69 201.597 259.639 201.5 259.568C201.403 259.496 201.321 259.407 201.259 259.303C201.196 259.2 201.154 259.085 201.135 258.966V258.966Z"
                        fill="white"
                    />
                    <path
                        d="M209.478 268.054L191.313 271.682C190.797 271.785 190.461 272.293 190.563 272.816L190.665 273.339C190.767 273.862 191.267 274.203 191.784 274.1L209.949 270.471C210.465 270.368 210.801 269.86 210.699 269.337L210.597 268.814C210.495 268.291 209.995 267.951 209.478 268.054Z"
                        fill="white"
                    />
                    <path
                        d="M208.917 260.173L188.883 264.174L190.56 272.8L210.594 268.798L208.917 260.173Z"
                        fill="#2E2E2E"
                    />
                    <path
                        d="M205.268 264.951C205.494 266.074 205.386 267.239 204.958 268.299C204.531 269.36 203.802 270.268 202.865 270.909C201.928 271.549 200.825 271.894 199.694 271.899C198.564 271.905 197.458 271.57 196.515 270.938C195.572 270.306 194.835 269.405 194.398 268.348C193.961 267.292 193.842 266.128 194.058 265.003C194.273 263.879 194.813 262.844 195.609 262.031C196.405 261.217 197.421 260.661 198.528 260.432C200.013 260.126 201.558 260.43 202.822 261.277C204.086 262.125 204.966 263.446 205.268 264.951V264.951Z"
                        fill="white"
                    />
                    <path
                        d="M204.434 265.115C204.627 266.071 204.534 267.064 204.17 267.967C203.805 268.871 203.184 269.644 202.386 270.19C201.587 270.736 200.647 271.029 199.684 271.034C198.721 271.038 197.778 270.752 196.975 270.213C196.172 269.675 195.545 268.906 195.172 268.006C194.8 267.106 194.7 266.114 194.884 265.156C195.068 264.198 195.528 263.317 196.207 262.624C196.885 261.931 197.751 261.457 198.695 261.263C199.96 261.003 201.275 261.263 202.351 261.985C203.427 262.707 204.176 263.833 204.434 265.115V265.115Z"
                        fill="#C8C8C8"
                    />
                    <path
                        d="M204.197 265.163C204.379 266.072 204.292 267.015 203.946 267.874C203.599 268.732 203.009 269.468 202.251 269.986C201.492 270.505 200.599 270.784 199.683 270.789C198.768 270.793 197.872 270.522 197.109 270.01C196.346 269.498 195.749 268.769 195.395 267.913C195.041 267.058 194.946 266.115 195.12 265.205C195.295 264.294 195.732 263.457 196.376 262.798C197.02 262.139 197.843 261.689 198.74 261.504C199.942 261.256 201.192 261.502 202.216 262.188C203.239 262.875 203.952 263.945 204.197 265.163Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M203.37 265.335C203.519 266.078 203.448 266.849 203.165 267.551C202.882 268.253 202.4 268.853 201.779 269.278C201.159 269.702 200.429 269.93 199.681 269.933C198.933 269.937 198.2 269.715 197.576 269.297C196.953 268.879 196.465 268.282 196.176 267.583C195.886 266.884 195.808 266.114 195.95 265.369C196.093 264.625 196.45 263.94 196.976 263.402C197.503 262.863 198.175 262.495 198.908 262.344C199.395 262.243 199.897 262.241 200.384 262.337C200.872 262.433 201.336 262.625 201.751 262.903C202.165 263.18 202.521 263.538 202.799 263.956C203.077 264.373 203.271 264.842 203.37 265.335V265.335Z"
                        fill="#4C4C4B"
                    />
                    <path
                        d="M199.173 263.417H199.156C198.434 263.577 197.803 264.018 197.399 264.644C196.995 265.271 196.85 266.033 196.995 266.767C197.14 267.501 197.564 268.148 198.175 268.569C198.786 268.989 199.536 269.15 200.262 269.016H200.28C201.002 268.856 201.632 268.415 202.036 267.788C202.44 267.162 202.586 266.399 202.44 265.665C202.295 264.931 201.872 264.285 201.261 263.864C200.65 263.443 199.9 263.283 199.173 263.417V263.417Z"
                        fill="#3A3A3A"
                    />
                    <path
                        d="M201.6 265.653C201.676 266.029 201.64 266.42 201.497 266.775C201.354 267.13 201.111 267.434 200.797 267.649C200.483 267.864 200.114 267.98 199.735 267.982C199.357 267.983 198.986 267.872 198.67 267.66C198.355 267.448 198.108 267.147 197.962 266.793C197.815 266.439 197.775 266.049 197.848 265.673C197.92 265.296 198.101 264.95 198.367 264.677C198.634 264.405 198.974 264.219 199.345 264.143C199.842 264.04 200.358 264.142 200.781 264.425C201.204 264.709 201.498 265.15 201.6 265.653V265.653Z"
                        fill="#3D3D3D"
                    />
                    <path
                        d="M200.911 265.796C200.959 266.033 200.936 266.28 200.846 266.504C200.756 266.728 200.602 266.92 200.404 267.056C200.206 267.191 199.973 267.264 199.734 267.266C199.495 267.267 199.261 267.196 199.062 267.063C198.862 266.929 198.707 266.739 198.614 266.516C198.521 266.293 198.496 266.047 198.542 265.809C198.587 265.571 198.701 265.352 198.869 265.18C199.037 265.008 199.252 264.89 199.486 264.842C199.8 264.777 200.126 264.841 200.393 265.02C200.66 265.199 200.847 265.478 200.911 265.796V265.796Z"
                        fill="#0F0F0E"
                    />
                    <path
                        opacity={0.2}
                        d="M198.818 265.165C198.865 265.398 198.843 265.64 198.754 265.86C198.665 266.081 198.513 266.27 198.319 266.403C198.124 266.536 197.895 266.608 197.66 266.609C197.425 266.61 197.195 266.54 196.999 266.409C196.803 266.277 196.65 266.09 196.559 265.87C196.468 265.651 196.444 265.409 196.489 265.175C196.534 264.941 196.646 264.726 196.812 264.557C196.977 264.388 197.188 264.273 197.419 264.226C197.571 264.194 197.729 264.193 197.882 264.223C198.035 264.253 198.181 264.313 198.311 264.401C198.441 264.488 198.552 264.6 198.639 264.731C198.726 264.863 198.787 265.01 198.818 265.165Z"
                        fill="white"
                    />
                    <path
                        d="M200.097 265.964C200.112 266.038 200.105 266.114 200.077 266.184C200.049 266.254 200.001 266.314 199.939 266.357C199.877 266.399 199.805 266.422 199.73 266.422C199.655 266.423 199.582 266.401 199.52 266.359C199.458 266.318 199.409 266.258 199.38 266.189C199.351 266.119 199.343 266.042 199.357 265.968C199.371 265.894 199.407 265.825 199.459 265.772C199.512 265.718 199.579 265.681 199.652 265.666C199.75 265.646 199.852 265.666 199.935 265.722C200.019 265.777 200.077 265.864 200.097 265.964V265.964Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M200.106 258.217L196.011 259.034L196.278 260.407L200.372 259.589L200.106 258.217Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M199.432 258.482L196.731 259.022C196.554 259.057 196.438 259.231 196.473 259.411L196.565 259.882C196.6 260.062 196.772 260.178 196.949 260.143L199.65 259.603C199.827 259.568 199.942 259.394 199.908 259.215L199.816 258.743C199.781 258.564 199.609 258.447 199.432 258.482Z"
                        fill="#3D3D3D"
                    />
                    <path
                        d="M207.311 268.29L207.105 268.594L206.231 268.098L206.61 267.54L207.311 268.29Z"
                        fill="#A8A7A7"
                    />
                    <path
                        d="M207.454 268.429C207.465 268.493 207.451 268.559 207.415 268.613C207.379 268.666 207.323 268.703 207.26 268.716C207.229 268.72 207.197 268.717 207.167 268.709C207.137 268.701 207.108 268.686 207.083 268.667C207.059 268.647 207.038 268.623 207.023 268.595C207.007 268.567 206.997 268.537 206.994 268.505C206.983 268.441 206.998 268.375 207.034 268.322C207.071 268.268 207.126 268.231 207.189 268.218C207.22 268.214 207.252 268.216 207.282 268.225C207.312 268.233 207.341 268.247 207.365 268.267C207.39 268.287 207.411 268.311 207.426 268.339C207.441 268.367 207.451 268.397 207.454 268.429Z"
                        fill="white"
                    />
                    <path
                        d="M206.876 267.746C206.898 267.874 206.87 268.006 206.797 268.113C206.724 268.22 206.613 268.294 206.487 268.319C206.425 268.328 206.362 268.324 206.302 268.308C206.241 268.292 206.185 268.263 206.135 268.225C206.086 268.186 206.044 268.138 206.013 268.083C205.982 268.028 205.963 267.967 205.955 267.904C205.934 267.776 205.962 267.644 206.035 267.537C206.108 267.43 206.219 267.356 206.345 267.331C206.407 267.322 206.47 267.326 206.53 267.342C206.59 267.359 206.647 267.387 206.696 267.426C206.746 267.464 206.787 267.513 206.818 267.568C206.849 267.623 206.869 267.683 206.876 267.746Z"
                        fill="white"
                    />
                    <path
                        d="M214.399 262.366L212.799 263.023L212.572 263.118C212.52 263.134 212.475 263.169 212.448 263.218C212.42 263.266 212.412 263.323 212.425 263.377C212.44 263.431 212.475 263.477 212.523 263.504C212.571 263.532 212.628 263.54 212.681 263.526L214.287 262.874L214.514 262.78C214.567 262.764 214.611 262.728 214.639 262.68C214.666 262.632 214.674 262.575 214.662 262.521C214.647 262.467 214.612 262.42 214.564 262.392C214.516 262.364 214.46 262.357 214.406 262.371L214.399 262.366Z"
                        fill="white"
                    />
                    <path
                        d="M215.251 266.198L213.814 266.286L213.605 266.299C213.577 266.299 213.55 266.304 213.525 266.315C213.499 266.326 213.476 266.341 213.457 266.361C213.437 266.381 213.422 266.404 213.411 266.43C213.401 266.455 213.396 266.483 213.396 266.511C213.396 266.539 213.401 266.566 213.411 266.592C213.422 266.618 213.437 266.641 213.457 266.661C213.476 266.68 213.499 266.696 213.525 266.707C213.55 266.717 213.577 266.723 213.605 266.723L215.042 266.634L215.251 266.622C215.306 266.62 215.359 266.597 215.397 266.557C215.436 266.517 215.458 266.464 215.459 266.408C215.458 266.352 215.436 266.299 215.396 266.259C215.357 266.22 215.304 266.198 215.249 266.198H215.251Z"
                        fill="white"
                    />
                    <path
                        d="M214.547 270.156L213.058 269.555L212.848 269.47C212.795 269.456 212.738 269.465 212.69 269.493C212.643 269.522 212.608 269.568 212.594 269.623C212.582 269.677 212.591 269.734 212.619 269.782C212.647 269.83 212.692 269.865 212.745 269.88L214.233 270.483L214.442 270.567C214.496 270.581 214.552 270.572 214.6 270.544C214.647 270.515 214.682 270.469 214.696 270.415C214.709 270.36 214.7 270.303 214.672 270.255C214.644 270.206 214.599 270.171 214.546 270.156H214.547Z"
                        fill="white"
                    />
                    <path
                        d="M212.511 273.516L211.505 272.509L211.36 272.362C211.321 272.323 211.267 272.301 211.212 272.301C211.156 272.301 211.103 272.324 211.064 272.364C211.025 272.404 211.004 272.458 211.004 272.515C211.004 272.571 211.027 272.625 211.066 272.664L212.071 273.671L212.216 273.818C212.256 273.852 212.308 273.87 212.36 273.867C212.413 273.864 212.463 273.842 212.5 273.804C212.537 273.766 212.559 273.715 212.561 273.662C212.563 273.609 212.545 273.556 212.511 273.516V273.516Z"
                        fill="white"
                    />
                    <path
                        d="M209.212 275.88L208.704 274.32L208.63 274.092C208.623 274.064 208.61 274.039 208.594 274.016C208.577 273.994 208.556 273.975 208.532 273.961C208.508 273.947 208.481 273.937 208.453 273.934C208.426 273.93 208.398 273.932 208.371 273.939C208.344 273.946 208.319 273.958 208.297 273.975C208.274 273.993 208.256 274.014 208.242 274.038C208.228 274.063 208.219 274.09 208.215 274.118C208.211 274.145 208.213 274.174 208.22 274.201L208.728 275.759L208.801 275.984C208.817 276.037 208.852 276.082 208.9 276.11C208.948 276.138 209.004 276.146 209.058 276.133C209.111 276.118 209.156 276.083 209.184 276.034C209.211 275.986 209.219 275.928 209.205 275.874L209.212 275.88Z"
                        fill="white"
                    />
                    <path
                        d="M205.492 276.626C205.492 276.165 205.49 275.703 205.486 275.241V275.043C205.486 274.987 205.464 274.933 205.424 274.893C205.385 274.854 205.332 274.831 205.276 274.831C205.221 274.831 205.168 274.854 205.129 274.893C205.089 274.933 205.067 274.987 205.067 275.043L205.076 276.428V276.626C205.076 276.682 205.098 276.736 205.137 276.776C205.176 276.816 205.229 276.838 205.285 276.838C205.34 276.838 205.393 276.816 205.433 276.776C205.472 276.736 205.494 276.682 205.494 276.626H205.492Z"
                        fill="white"
                    />
                    <path
                        d="M201.729 275.866C201.887 275.378 202.045 274.89 202.201 274.402L202.27 274.193C202.283 274.138 202.275 274.079 202.246 274.031C202.218 273.982 202.171 273.947 202.117 273.933C202.09 273.926 202.062 273.924 202.034 273.928C202.007 273.932 201.98 273.942 201.956 273.956C201.908 273.985 201.874 274.033 201.86 274.088C201.703 274.575 201.545 275.063 201.387 275.552L201.32 275.761C201.306 275.816 201.315 275.874 201.343 275.923C201.372 275.972 201.419 276.007 201.473 276.021C201.527 276.035 201.585 276.027 201.633 275.997C201.681 275.968 201.716 275.921 201.73 275.866H201.729Z"
                        fill="white"
                    />
                    <path
                        d="M200.908 283.68C196.33 283.68 191.939 281.837 188.702 278.556C185.464 275.275 183.646 270.825 183.646 266.185C183.646 261.546 185.464 257.096 188.702 253.815C191.939 250.534 196.33 248.691 200.908 248.691C210.427 248.691 218.172 256.539 218.172 266.185C218.172 275.831 210.427 283.68 200.908 283.68ZM200.908 248.943C197.543 248.943 194.253 249.954 191.455 251.849C188.657 253.744 186.476 256.437 185.188 259.588C183.9 262.739 183.563 266.206 184.22 269.551C184.877 272.896 186.497 275.969 188.877 278.38C191.257 280.792 194.289 282.434 197.59 283.099C200.89 283.764 204.312 283.423 207.421 282.117C210.53 280.812 213.187 278.602 215.057 275.766C216.926 272.93 217.924 269.596 217.924 266.185C217.919 261.614 216.124 257.231 212.934 253.998C209.744 250.766 205.419 248.948 200.908 248.943V248.943Z"
                        fill="white"
                    />
                </g>
            </g>

            <defs>
                <linearGradient
                    id="paint0_linear"
                    x1={201.034}
                    y1={303.934}
                    x2={186.979}
                    y2={274.937}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A8141D" />
                    <stop offset={0.1} stopColor="#B7181D" />
                    <stop offset={0.33} stopColor="#D31F1D" />
                    <stop offset={0.55} stopColor="#E8251D" />
                    <stop offset={0.78} stopColor="#F4281D" />
                    <stop offset={1} stopColor="#F8291D" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear"
                    x1={200.64}
                    y1={302.324}
                    x2={187.711}
                    y2={275.65}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F8291D" />
                    <stop offset={0.22} stopColor="#F4281D" />
                    <stop offset={0.45} stopColor="#E8251D" />
                    <stop offset={0.67} stopColor="#D31F1D" />
                    <stop offset={0.9} stopColor="#B7181D" />
                    <stop offset={1} stopColor="#A8141D" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear"
                    x1={-115297}
                    y1={-152120}
                    x2={-120633}
                    y2={-154726}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A8141D" />
                    <stop offset={0.1} stopColor="#B7181D" />
                    <stop offset={0.33} stopColor="#D31F1D" />
                    <stop offset={0.55} stopColor="#E8251D" />
                    <stop offset={0.78} stopColor="#F4281D" />
                    <stop offset={1} stopColor="#F8291D" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear"
                    x1={-106276}
                    y1={-139813}
                    x2={-110801}
                    y2={-142038}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F8291D" />
                    <stop offset={0.22} stopColor="#F4281D" />
                    <stop offset={0.45} stopColor="#E8251D" />
                    <stop offset={0.67} stopColor="#D31F1D" />
                    <stop offset={0.9} stopColor="#B7181D" />
                    <stop offset={1} stopColor="#A8141D" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear"
                    x1={186.868}
                    y1={251.935}
                    x2={215.521}
                    y2={280.207}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF9E00" />
                    <stop offset={0.29} stopColor="#FF9A00" />
                    <stop offset={0.59} stopColor="#FF8E01" />
                    <stop offset={0.89} stopColor="#FF7903" />
                    <stop offset={1} stopColor="#FF7004" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear"
                    x1={187.708}
                    y1={252.783}
                    x2={214.662}
                    y2={279.382}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF7004" />
                    <stop offset={0.11} stopColor="#FF7903" />
                    <stop offset={0.41} stopColor="#FF8E01" />
                    <stop offset={0.71} stopColor="#FF9A00" />
                    <stop offset={1} stopColor="#FF9E00" />
                </linearGradient>
                <clipPath id="clip0">
                    <rect width={40} height={60.3191} fill="white" transform="translate(181 246)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default PhotoUploadBaloonPrizeContestMobile;
